/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailTemplate
 */
export interface EmailTemplate {
    /**
     * 
     * @type {string}
     * @memberof EmailTemplate
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplate
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplate
     */
    footer: string;
}

/**
 * Check if a given object implements the EmailTemplate interface.
 */
export function instanceOfEmailTemplate(value: object): value is EmailTemplate {
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('footer' in value) || value['footer'] === undefined) return false;
    return true;
}

export function EmailTemplateFromJSON(json: any): EmailTemplate {
    return EmailTemplateFromJSONTyped(json, false);
}

export function EmailTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': json['subject'],
        'body': json['body'],
        'footer': json['footer'],
    };
}

export function EmailTemplateToJSON(value?: EmailTemplate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'subject': value['subject'],
        'body': value['body'],
        'footer': value['footer'],
    };
}

